import ArticleCardVertical from "../../../../../view/components/ArticleCardVertical/ArticleCardVertical";

export default function Featured({ featuredPosts }) {
    return (
        <>
            <h3 className="text-3xl font-semibold pt-4 pb-4 border-b border-gray-200 max-w-screen-xl m-auto">
                Izdvojeni članci
            </h3>
            <div className="max-w-screen-xl mx-auto mb-8 leading-loose">
                <section className="flex flex-col md:flex-row md:space-x-16 text-gray-600 body-font overflow-hidden">
                    <div className="md:w-2/3">
                        {featuredPosts?.length > 0 && (
                            <ArticleCardVertical
                                key={featuredPosts[0]._id}
                                post={featuredPosts[0]}
                                readMore={true}
                                hasText={true}
                                size="big"
                            />
                        )}
                    </div>
                    <div className="md:w-1/3">
                        {featuredPosts?.length > 1 && (
                            <ArticleCardVertical
                                key={featuredPosts[1]._id}
                                post={featuredPosts[1]}
                                readMore={false}
                                hasText={false}
                            />
                        )}

                        {featuredPosts?.length > 2 && (
                            <ArticleCardVertical
                                key={featuredPosts[2]._id}
                                post={featuredPosts[2]}
                                readMore={false}
                                hasText={false}
                            />
                        )}
                    </div>
                </section>
            </div>
        </>
    );
}
